import React from "react";
import { useLang } from "../LanguageContext";
import { Reveal, Overline } from "./Reveal";

const Row = ({ reverse, PARTNERS }) => (
  <div className="marquee-track" style={reverse ? { animationDirection: "reverse" } : undefined}>
    {[...PARTNERS, ...PARTNERS].map((p, i) => (
      <span key={i} className="px-8 md:px-12 font-serif text-3xl md:text-5xl font-light text-ink/25 hover:text-gold transition-colors duration-500 whitespace-nowrap">
        {p}
      </span>
    ))}
  </div>
);

const Partners = () => {
  const { t, partners } = useLang();
  const PARTNERS = partners;
  return (
    <section id="partners" className="bg-paper-warm py-24 md:py-32 overflow-hidden">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 mb-14 md:mb-20">
        <Reveal><Overline>{t.partners.overline}</Overline></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif text-ink font-light leading-[1.05] text-3xl md:text-5xl mt-6 max-w-3xl">
            {t.partners.title}
          </h2>
        </Reveal>
      </div>
      <div className="space-y-6 md:space-y-8">
        <Row PARTNERS={PARTNERS} />
        <Row reverse PARTNERS={PARTNERS} />
      </div>
    </section>
  );
};

export default Partners;
